import { COUNTRY } from '../CountryUtils';
import EuropePrivacyPolicy from './Europe/PrivacyPolicy';
import USPrivacyPolicy from './America/US/PrivacyPolicy';
import CanadaPrivacyPolicy from './America/Canada/PrivacyPolicy';

const privacyPolicy = {
    [COUNTRY.UK]: EuropePrivacyPolicy,
    [COUNTRY.FRANCE]: EuropePrivacyPolicy,
    [COUNTRY.SPAIN]: EuropePrivacyPolicy,
    [COUNTRY.GERMANY]: EuropePrivacyPolicy,
    [COUNTRY.SWITZERLAND]: EuropePrivacyPolicy,
    [COUNTRY.BELGIUM]: EuropePrivacyPolicy,
    [COUNTRY.US]: USPrivacyPolicy,
    [COUNTRY.CANADA]: CanadaPrivacyPolicy,
};

export const getPrivacyPolicyByCountry = (country) => privacyPolicy[country];
